import { memo, MouseEvent, PropsWithChildren, useCallback, useEffect } from 'react';

export type BasicModalProps = PropsWithChildren<{
  isOpen?: boolean;
  onDismiss?: () => void;
}>;

const IBasicModal = ({ children, isOpen, onDismiss }: BasicModalProps) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onDismiss?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onDismiss]);

  const handleOverlayClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      if (event.target !== event.currentTarget) {
        return;
      }

      onDismiss?.();
    },
    [onDismiss]
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm">
      <div className="fixed inset-0 flex items-center justify-center bg-transparent" onClick={handleOverlayClick}>
        <div className="rounded-lg border-1 border-gray-200 bg-white shadow-lg">{children}</div>
      </div>
    </div>
  );
};

export const BasicModal = memo(IBasicModal) as typeof IBasicModal;
